import React, { useState, useEffect } from 'react';
import {
  Row, Input, Button, Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { putAPI_Update_Response } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import ImageGallery from '../../gallery/index'

function ImgLink({
  reloadBotResponse,
  caption,
  url,
  code,
  messages,
  urls,
  captions,
  details,
  index,
  setIsEditingToFalse,
  setIsAddImageToFalse,
  isAddImage,
  /** Globle property id from redux */
  propertyId,
  apiButtons,
  SaveRecommenderQuestionCode,
  locale
}) {
  const [urlInput, setUrlInput] = useState(url || '');
  const [captionInput, setCaptionInput] = useState(caption || '');
  const [galleryVisible, setGalleryVisible] = useState(false);

  const [postData, setPostData] = useState({
    GroupId: getGroupID(),
    Code: code,
    Language: `${locale === 'en' ? 'en-US' : locale}`,
    Channel: 'WebsiteDirectLine',
    PropertyId: propertyId,
    Default: null,
    Overrides: {},
  });

  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };

  const selectedImage = (link) => {
    setUrlInput(link.src)
    setCaptionInput(link.caption)
  };

  useEffect(() => {
    //console.log('details', details);
    let imageList = [];
    setPostData(pre => {
      if (!isAddImage) {
        imageList = urls.map((url, index) => {
          const imgCaption = captions[index];
          return { Url: url, Caption: imgCaption };
        });
        imageList[index].Url = urlInput;
        imageList[index].Caption = captionInput;
      }

      if (isAddImage) {
        let idx = urls.length - 1;
        imageList = urls.map((url, index) => {
          const imgCaption = captions[index];
          return { Url: url, Caption: imgCaption };
        });
        imageList[idx + 1] = { Url: '', Caption: '' };
        imageList[idx + 1].Url = urlInput;
        imageList[idx + 1].Caption = captionInput;
        // console.log('object', idx);
      }

      //console.log('imageList', imageList);
      return {
        ...pre,
        Default: {
          Messages: messages,
          Images: imageList,
          apiButtons: apiButtons
        },
      };
    });
    //console.log('Image Post Data', postData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlInput, captionInput]);

  const handleCaptionChange = e => {
    setCaptionInput(e.target.value);
  };

  const handleUrlChange = e => {
    setUrlInput(e.target.value);
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={galleryVisible} toggle={togglegallery} style={{ maxWidth: '1000px' }}>
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                            </ModalHeader>
                <ModalBody>
                  <ImageGallery propertyId={propertyId} selectedImage={selectedImage} togglegallery={togglegallery}
                    hideUserUploads={false} searchText={""} />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const handleSave = async () => {
    try {
      return await AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_Response}`,
        data: postData,
      })
        .then(() => {
          if (setIsEditingToFalse) {
            setIsEditingToFalse();
          }
          if (setIsAddImageToFalse) {
            setIsAddImageToFalse();
          }
        })
        .finally(
          setTimeout(() => {
            if (SaveRecommenderQuestionCode !== undefined) {
              SaveRecommenderQuestionCode();
            }
            else {
              reloadBotResponse();
            }
          }, 1000)
        );
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancel = () => {
    if (setIsEditingToFalse) {
      setIsEditingToFalse();
    }
    if (setIsAddImageToFalse) {
      setIsAddImageToFalse();
    }
  };
  return (
    <div>
      <Row>
        <Colxx xxs="4">Caption</Colxx>
        <Colxx xxs="8">
          <Input
            type="text"
            value={captionInput}
            onChange={handleCaptionChange}
          ></Input>
        </Colxx>
      </Row>
      <Row>
        <Colxx xxs="4">Image Link</Colxx>
        <Colxx xxs="8">
          <Input
            type="text"
            value={urlInput}
            onChange={handleUrlChange}
          ></Input>
        </Colxx>
      </Row>
      <Row>
        <Colxx xxs="4">
        </Colxx>
        <Colxx xxs="8">
          <div
            className="float-left"
            style={{ marginTop: ' 5px', marginBottom: '5px' }}
          >
            <Button color="primary" className="add-button" size="xs" onClick={togglegallery}>
              Browse Gallery
                    </Button>
          </div>
          <div
            className="float-right"
            style={{ marginTop: ' 5px', marginBottom: '5px' }}
          >

            <Button
              color="secondary"
              className="add-button"
              size="xs"
              onClick={handleSave}
            >
              Save
            </Button>
            <b> </b>
            <Button
              color="light"
              className="add-button"
              size="xs"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </Colxx>
      </Row>
      {ImageGalleryButton()}
    </div>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};

export default injectIntl(connect(mapStateToProps)(ImgLink));
